//会话管理
const session = {
	setUser: function (data) {
		if(data.token){
			session.setToken(data.token);
		}else{
			data.token = this.getToken();
		}
		return session.setObj("user", data);
	},
	removeUser: function () {
		return session.setObj("user", null);
	},
	getUser: function () {
		return session.getObj("user");
	},
	getUserId: function () {
		let u = session.getUser();
		if( u){
			return  u.id;
		}else{
			return '';
		}
	},
	setToken: function (token) {
		return localStorage.setItem('token', token);
	},
	getToken: function () {
		return localStorage.getItem('token');
	},
	set: function (key,value) {
		return localStorage.setItem(key, value);
	},
	get: function (key) {
		return localStorage.getItem(key);
	},
	setObj: function (key, value) {
		return localStorage.setItem(key, JSON.stringify(value));
	},
	getObj: function (key) {
		var value = localStorage.getItem(key);
		if (value) {
			return JSON.parse(value);
		} else {
			return null;
		}
	}
}
export default session



// WEBPACK FOOTER //
// ./src/common/js/session.js